import { Navigate, Outlet } from 'react-router'
import { useAuth } from '@/features/auth/AuthContext'
import { ROUTES } from '@/shared/routes'

export const PublicRoute = () => {
  const { isAuthenticated } = useAuth()

  if (isAuthenticated) return <Navigate to={ROUTES.HOME} replace />
  return <Outlet />
}
